import {FC, useEffect, useMemo, useState} from "react"
import { VideoJS } from "components"
import { retrieveEncFile, baseRESTUrl } from "lib/utils";
import { usePack } from "lib/hooks";
import { usePackContext } from "domains/pack";

export const AssetVideoFile: FC<any> = ({ asset }) => {
  const { id, data: { url, content_type } } = asset;
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const [ videoUrl, setVideoUrl ] = useState<string>(null);

  useEffect(() => {
    (async () => {
      let videoUrl = `${baseRESTUrl()}/v1/packs/${pack.id}/files/${id}`;

      if (pack.is_encrypted) {
        videoUrl = await retrieveEncFile(pack.id, id, content_type, pack.key);
      }
      else if (url) {
        videoUrl = `${baseRESTUrl()}/v1/packs/${pack.id}/files/${url}`; // backwards compatibility
      }

      if (videoUrl) setVideoUrl(videoUrl);
    })();
  }, [ pack, url, content_type, setVideoUrl ]);

  const videoJsOptions = useMemo(() => {
    let sources = [{
      src: videoUrl,
      type: content_type,
      withCredentials: true
    }];

    return {
      controls: true,
      responsive: true,
      fluid: true,
      sources
    }
  }, [ videoUrl, content_type ]);

  if (!videoUrl) {
    return null;
  }

  return (
    <VideoJS options={videoJsOptions}  />
  );
};
